import React from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {startLogout} from '../actions/auth'

export const Header = ({startLogout}) => (
  <header>
    <div className="content-container">
      <div className="header__content">
        <Link className="header__title" to="/dashboard"><h1>xpensr</h1></Link>
        <button className="header__button" onClick={startLogout}>logout</button>
      </div>
    </div>
  </header>
)

const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout())
})

export default connect(undefined, mapDispatchToProps)(Header)


// WEBPACK FOOTER //
// ./src/components/Header.js